import {
  getLogbooksMockHandler,
  startLogbookMockHandler,
  submitLogbookMockHandler,
} from '@/features/logbooks/api';
import { sendReferralMockHandler } from '@/features/referral/api';
import {
  getVideoSegmentationDataMockHandler,
  getProfilesMockHandler,
  selectProfileMockHandler,
  selectVariantMockHandler,
  getReferralDataMockHandler,
} from '@/features/user/api';

export const userHandlers = [
  getProfilesMockHandler,
  selectProfileMockHandler,
  selectVariantMockHandler,
  getVideoSegmentationDataMockHandler,
  getReferralDataMockHandler,
  getLogbooksMockHandler,
  startLogbookMockHandler,
  submitLogbookMockHandler,
  sendReferralMockHandler,
];
